import { loginCodeVerificationSubmit } from '../../../actions/userActions';
import Messages from '../Messages';
import { Field, Form } from 'react-final-form';
import { connect } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router';

const LoginCodeVerificationForm = ({ content, hasVerificationError, loginCodeVerificationSubmit }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email ?? '';
  const showPasswordSuccessMessage = !hasVerificationError;

  const onSubmit = async (values) => {
    try {
      const result = await loginCodeVerificationSubmit(values);
      if (result?.twoFaInvalidated || result?.twoFaSessionExpired) {
        navigate('/login', { replace: true, state: { flashDanger: result.flashMessage } });
      }
    } catch (err) {
      if (err?.twoFaInvalidated || err?.twoFaSessionExpired) {
        navigate('/login', { replace: true, state: { flashDanger: err.flashMessage } });
      }
    }
  };

  return (
    <div className="ContactPage">
      <div className="container content">
        <div className="bg-light-grey">
          <section style={{ maxWidth: '60ch' }}>
            <header>
              <h3>{content.title}</h3>
            </header>

            <div className="mt-3">
              <Messages />
              {showPasswordSuccessMessage && (
                <div className="alert alert-success" role="alert">
                  Thank you. Your email and password were correct.
                </div>
              )}
            </div>

            <p className="fw-bold">
              As an extra layer of security we need to confirm you have access to your email. We have sent you an email with a 6-character
              code
              {email ? (
                <>
                  {' '}
                  to <span className="text-nowrap">{`"${email}"`}</span>.
                </>
              ) : (
                '.'
              )}
            </p>

            <Form
              onSubmit={onSubmit}
              initialValues={{ email }}
              render={({ handleSubmit, submitting }) => (
                <form onSubmit={handleSubmit}>
                  <Field name="email" component="input" type="hidden" />
                  <div className="form-group mb-1">
                    <label className="control-label" htmlFor="login_confirmation_code">
                      Enter the code below to verify your identity and complete logging in:
                    </label>
                    <Field
                      id="login_confirmation_code"
                      name="confirmationCode"
                      component="input"
                      type="text"
                      className="form-control text w-50"
                      maxLength={6}
                      disabled={submitting}
                      autoComplete="off"
                      data-lpignore="true"
                      data-1p-ignore="true"
                      data-bwignore="true"
                    />
                  </div>
                  <div className="Actions float-none mb-4 mt-2">
                    <button className="action btn btn-primary d-block" type="submit" disabled={submitting}>
                      {content.buttonText}
                    </button>
                  </div>
                </form>
              )}
            />

            <div className="d-block mb-5">
              You should receive the code within a few minutes. If you do not see it, please check your spam or junk folder. The code will
              expire 30 minutes after it is sent.
            </div>

            <Link to="/login" className="d-block text-decoration-underline">
              {content.loginLinkText || 'Back to login'}
            </Link>
          </section>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const defaultContent = {
    title: 'Enter confirmation code',
    buttonText: 'Verify code',
    loginLinkText: 'Back to login',
  };

  const configContent = state.config?.content?.loginCodeVerification || {};

  return {
    content: {
      ...defaultContent,
      ...configContent,
    },
    hasVerificationError: state.messages.some((msg) => msg.messageType === 'danger'),
  };
};

const mapDispatchToProps = {
  loginCodeVerificationSubmit,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginCodeVerificationForm);
